import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "./Job.scss";
import "react-datepicker/dist/react-datepicker.css";
import SoftButton from "StyleFeatures/SoftButton";
import jobService from "../APIServices/jobService";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Footer from "Common/Footer";
import { Card } from "antd";

function JobS({ onBack, onNext, initialData = {}, jobData = {} }) {
  const {
    jobFormData,
    setJobFormData,
    jobFormDataError,
    handleJobChange,
    validateStep2,
    designations,
  } = jobService();

  // Initialize form with initialData when component mounts (for navigating back)
  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      setJobFormData((prev) => ({
        ...prev,
        ...initialData,
      }));
    }
  }, [initialData, setJobFormData]);

  useEffect(() => {
    if (jobData?.departmentId) {
      setJobFormData((prev) => ({
        ...prev,
        departmentId: jobData.departmentId,
      }));
    }
  }, [jobData, setJobFormData]);

  const handleBack = () => {
    onBack();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = validateStep2();
    if (isValid) {
      const selectedDesignation = designations.find((d) => d.id === jobFormData.designationId);
      const designationName = selectedDesignation?.name || "Unknown Position";
      const dataForParent = {
        hiringDate: jobFormData.hiringDate,
        probationStartDate: jobFormData.probationStartDate,
        probationEndDate: jobFormData.probationEndDate,
        designationId: jobFormData.designationId,
        baseSalary: jobFormData.baseSalary,
        designationName: designationName,
      };

      dataForParent.hiringDate = jobFormData.hiringDate;
      dataForParent.probationStartDate = jobFormData.probationStartDate;
      dataForParent.probationEndDate = jobFormData.probationEndDate;
      dataForParent.designationId = jobFormData.designationId;
      dataForParent.baseSalary = jobFormData.baseSalary;

      dataForParent.designationName = designationName;
      onNext(dataForParent);
    }
  };

  return (
    <div className="body flex-grow-1 px-3">
      <Card title="Job" className="card-professional">
        <div className="row">
          <ToastContainer />
          <form encType="multipart/form-data">
            <div className="row">
              {/* Hiring Date */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label" style={{ fontSize: "medium" }}>
                    Hiring Date *
                  </label>
                  <input
                    type="date"
                    name="hiringDate"
                    value={jobFormData?.hiringDate || ""}
                    onChange={handleJobChange}
                    className={`form-control ${
                      jobFormDataError?.hiringDateError ? "is-invalid" : ""
                    }`}
                  />
                  {jobFormDataError?.hiringDateError && (
                    <div className="invalid-feedback">{jobFormDataError.hiringDateError}</div>
                  )}
                </div>
              </div>

              {/* Probation Start Date */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label" style={{ fontSize: "medium" }}>
                    Probation Start Date *
                  </label>
                  <input
                    type="date"
                    name="probationStartDate"
                    value={jobFormData?.probationStartDate || ""}
                    onChange={handleJobChange}
                    className={`form-control ${
                      jobFormDataError?.probationStartDateError ? "is-invalid" : ""
                    }`}
                  />
                  {jobFormDataError?.probationStartDateError && (
                    <div className="invalid-feedback">
                      {jobFormDataError.probationStartDateError}
                    </div>
                  )}
                </div>
              </div>

              {/* Probation End Date */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label" style={{ fontSize: "medium" }}>
                    Probation End Date *
                  </label>
                  <input
                    type="date"
                    name="probationEndDate"
                    value={jobFormData?.probationEndDate || ""}
                    onChange={handleJobChange}
                    className={`form-control ${
                      jobFormDataError?.probationEndDateError ? "is-invalid" : ""
                    }`}
                  />
                  {jobFormDataError?.probationEndDateError && (
                    <div className="invalid-feedback">{jobFormDataError.probationEndDateError}</div>
                  )}
                </div>
              </div>
            </div>

            <div className="row mt-3">
              {/* Designation Dropdown */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label" style={{ fontSize: "medium" }}>
                    Designation *
                  </label>
                  <select
                    name="designationId"
                    value={jobFormData?.designationId || ""}
                    onChange={handleJobChange}
                    className={`form-control ${
                      jobFormDataError?.designationIdError ? "is-invalid" : ""
                    }`}
                  >
                    <option value="">Select Designation</option>
                    {designations?.map((des) => (
                      <option key={des.id} value={des.id}>
                        {des.name}
                      </option>
                    ))}
                  </select>{" "}
                  {jobFormDataError?.designationIdError && (
                    <div className="invalid-feedback">{jobFormDataError.designationIdError}</div>
                  )}
                </div>
              </div>

              {/* Base Salary */}
              <div className="col-md-4">
                <div className="form-group">
                  <label className="form-label" style={{ fontSize: "medium" }}>
                    Base Salary *
                  </label>
                  <input
                    type="number"
                    step="0.01"
                    name="baseSalary"
                    value={jobFormData?.baseSalary || ""}
                    onChange={handleJobChange}
                    placeholder="Enter Base Salary"
                    className={`form-control ${
                      jobFormDataError?.baseSalaryError ? "is-invalid" : ""
                    }`}
                  />
                  {jobFormDataError?.baseSalaryError && (
                    <div className="invalid-feedback">{jobFormDataError.baseSalaryError}</div>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-12 mt-3">
          <SoftButton
            variant="outlined"
            style={{ float: "inline-end" }}
            className="btn-primary"
            size="small"
            onClick={handleSubmit}
          >
            Next
          </SoftButton>
          <SoftButton
            variant="outlined"
            style={{ float: "inline-end", marginRight: "10px" }}
            className="btn-back"
            size="small"
            onClick={handleBack}
          >
            Back
          </SoftButton>
        </div>
      </Card>
      <Footer />
    </div>
  );
}

JobS.propTypes = {
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  initialData: PropTypes.object,
  jobData: PropTypes.object,
};

JobS.defaultProps = {
  initialData: {},
  jobData: {},
};

export default JobS;
